
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.405 2.525a7 7 0 016.283 2.894V4.031a.656.656 0 111.313 0v3.72h-3.72a.656.656 0 110-1.313h1.512A5.688 5.688 0 003.483 8.12a.656.656 0 11-1.274-.318 7 7 0 016.196-5.277zM5.43 15.522a7 7 0 0010.36-4.324.656.656 0 00-1.272-.319 5.688 5.688 0 01-10.31 1.684h1.511a.656.656 0 100-1.313H2v3.72a.656.656 0 101.313 0v-1.388a7.002 7.002 0 002.117 1.94z","fill":"#133C6B"}})])
          )
        }
      }
    